import React, { useState } from "react";
import ModeSelector from "./ModeSelector";
import ChatView from "./ChatView";
import styles from "./ChatbotPanel.module.css";

const ChatbotPanel = ({ onClose , embedded = false }) => {
  const [step, setStep] = useState("select"); // select | chat
  const [mode, setMode] = useState(null);     // courses | jobs | profile

  const handleSelect = (selectedMode) => {
    setMode(selectedMode);
    setStep("chat");
  };

  const handleBack = () => {
    setMode(null);
    setStep("select");
  };

  return (
    <div
      className={`${styles.panel} ${
        embedded ? styles.embedded : styles.fullpage
      }`}
      style={{
        height: embedded ? "100%" : "100dvh",
      }}
    >
      {step === "select" && (
        <ModeSelector onSelect={handleSelect} onClose={onClose} embedded={embedded} />
      )}

      {step === "chat" && (
        <ChatView mode={mode} onBack={handleBack} onClose={onClose} embedded={embedded} />
      )}
    </div>
  );
};

export default ChatbotPanel;
